import React, {Component} from 'react';
import {Modal, NavBar, SearchBar, Toast} from 'antd-mobile';
import "./style.less";
import {lifeInfo} from "../../service/addLines";
import connect from "react-redux/es/connect/connect";
const bbb1 = require('../../common/image/bbb1.jpg');

@connect(
    state => ({userInfo: state.userInfo})
)
export default class FileDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            detailType:"",
            detailData:{}
        };
    }
    componentDidMount() {
        console.log(this.props.match.params.id)
        this.getData(this.props.match.params.id)
        if(this.props.location.state !== undefined){
            this.setState({detailType:this.props.location.state.type})
        }
    }
    getData(id){
        const params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
               id:id
            }
        };
        lifeInfo(params).then((res)=>{
            if(res.data.code === '0000'){
               this.setState({detailData:res.data.data})
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    render(){
        const  {detailData}=this.state;
        return(
            <div className="lifeDetail">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >详情</NavBar>
                {
                    detailData.status == 98 ? (
                        <div className="reason">
                            <div className=""><span>下架日期：</span> {detailData.soldOutDte}</div>
                            <div className=""><span>下架原因：</span> {detailData.soldOutReason}</div>
                        </div>
                    ):null
                }

                <div className="wrap">
                    <div className="lifeTop">
                        <img src={detailData.headimgurl}/>
                        <div className="">
                            <div className="name">{detailData.nickname}</div>
                            {/*<div className="dizhi">{detailData.releaseAddress} 距离我 <span>{detailData.releaseAddress + 'km'}</span></div>*/}
                            <div className="dizhi">{detailData.releaseAddress} </div>
                            {/*距离我 <span>{detailData.releaseAddress + 'km'}</span>*/}
                        </div>
                    </div>
                    <div className="con">
                        {detailData.content}
                        {
                            detailData.photoList && detailData.photoList.map((res,i)=>(
                                <img src={res} key={i}/>
                            ))
                        }
                    </div>
                    <div className="time">{detailData.createDate}</div>
                </div>
               <div className="footer">
                   <p>温馨提示</p>
                   <p>请仔细鉴别信息真伪，如发现虚假、诈骗信息请立即举报！</p>
                   <p className="phone">客服电话400-1389889</p>
               </div>
                <div className="footerBar">
                    <span>联系人: {detailData.contacts}</span>
                    <button><a href={`tel:${detailData.contactsPhone}`}>拨打电话</a></button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/MtLife/FileDetail.js